module.exports = __webpack_public_path__ + "img/feature-11.03ef1604.jpg";